import { render, staticRenderFns } from "./VerifactuIcon.vue?vue&type=template&id=bec3e15e"
var script = {}
import style0 from "./VerifactuIcon.vue?vue&type=style&index=0&id=bec3e15e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports